import React from 'react';
import Navbar from '../components/Navbar';
import Accounts from '../components/Accounts';
import Footer from '../components/Footer';

const PageAccounts = () => {
  return (
    <div className="page-container">
      <Navbar />
      <Accounts />
    </div>
  );
};

export default PageAccounts;
